import { create } from "zustand";
import { persist } from "zustand/middleware";

const ONE_DAY_MS = 86400 * 1000;

interface TactGloveVrchatPopupState {
  dismissedUntil: number;
  dismiss: () => void;
}

/**
 * 홈 팝업의 TactGlove DK3 VRChat 슬라이드(#6025) 「오늘은 다시 보지 않기」 상태.
 *
 * `popup-banner-store`(GTA5)·`welcome-coupon-popup-store` 와 같은 형태지만 저장 키를
 * 나눈다 — 한 저장소를 공유하면 한 슬라이드를 끌 때 다른 캠페인까지 함께 꺼진다
 * (*"해당 장면의 이벤트만 영향"*, 2026-09-10 작성자 확정). 오늘 닫혔는지 판정은
 * `popup-banner-store` 의 `isDismissedToday` 를 같이 쓴다.
 */
export const useTactGloveVrchatPopupStore = create<TactGloveVrchatPopupState>()(
  persist(
    (set) => ({
      dismissedUntil: 0,
      dismiss: () => set({ dismissedUntil: Date.now() + ONE_DAY_MS }),
    }),
    {
      name: "tactglove-vrchat-popup",
      partialize: (state) => ({ dismissedUntil: state.dismissedUntil }),
    },
  ),
);
